import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { bootTelegram } from "./telegram/sdk.js";
import "./index.css";

bootTelegram();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
